// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"9317654b","36":"6fced608","252":"49064b33","271":"600ef268","508":"9bebbf15","527":"8dcedee7","599":"1dc80ca3","655":"6fced608","696":"a9030766","928":"2d50aedd"}[chunkId] + ".chunk.css";
};